<template>
    <div class="vrm-info-tooltip" @mouseenter="show" @mouseleave="hide">
        <span class="sg-vrm-icon_061_info-round-16px"></span>
        <div v-show="visible" class="vrm-info-tooltip__container">
            <div class="vrm-info-tooltip__body">
                <span
                    class="sg-vrm-icon_055_cross-16px vrm-info-tooltip__close"
                    @click="hide"
                ></span>
                <div class="vrm-info-tooltip__arrow"></div>
                <div class="vrm-info-tooltip__content"><slot /></div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularDirective } from '@/vue/decorators/angular-interop';

@Component
@AngularDirective('vrm-info-tooltip')
export default class VrmInfoTooltip extends Vue {
    visible = false;

    show() {
        this.visible = true;
    }

    hide() {
        this.visible = false;
    }
}
</script>
